import { render, staticRenderFns } from "./VuesticSlider.vue?vue&type=template&id=75f1b323"
import script from "./VuesticSlider.vue?vue&type=script&lang=js"
export * from "./VuesticSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-slider/VuesticSlider.vue
// module id = fPvY
// module chunks = 41